document.addEventListener('DOMContentLoaded', function () {
    if (document.getElementById('wishlist-grid')) {
        displayWishlist();
    }

    refreshAllWishlistButtons();
});

document.addEventListener('cart-drawer:open', function () {
    refreshAllWishlistButtons();
});

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.wishlist_button').forEach(button => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            toggleWishlist(button);
        });
    });
});

/**
 * Retrieves the wishlist from localStorage
 * @returns {Array} Wishlist array
 */
function getWishlist() {
    return JSON.parse(localStorage.getItem('wishlist')) || [];
}

/**
 * Saves the wishlist to localStorage
 * @param {Array} wishlistData Wishlist array to save
 */
function saveWishlist(wishlistData) {
    localStorage.setItem('wishlist', JSON.stringify(wishlistData));
}

/**
 * Toggles a product in the wishlist
 */
function toggleWishlist(button) {
    const pdpData = {
        id: generateUUID(),
        di: generateUUID().slice(0, 8), // short UUID
        handle: button.dataset.handle,
        vo: button.dataset.variantOption,
        epi: button.dataset.variantId,
        empi: button.dataset.productId,
        dt: button.dataset.title,
        iu: button.dataset.img,
        pr: button.dataset.price,
        currency: button.dataset.currency,
        du: button.dataset.url,
        sku: button.dataset.sku,
        vi: button.dataset.variantTitle,
        pid: btoa(button.dataset.productId + '-' + button.dataset.variantId),
        cts: Date.now(),
        uts: Date.now()
    };

    let wishlistData = getWishlist();
    const wishlistText = button.querySelector('.wishlist_text');

    const isAlreadyInWishlist = wishlistData.some(item =>
        item.epi === pdpData.epi
    );

    if (isAlreadyInWishlist) {
        // Remove
        wishlistData = wishlistData.filter(item => item.epi !== pdpData.epi);
        button.classList.remove('wishlist-added');
        if (wishlistText) wishlistText.textContent = "Save To Wishlist";
    } else {
        // Add
        wishlistData.push(pdpData);
        button.classList.add('wishlist-added');
        if (wishlistText) wishlistText.textContent = "Saved To Wishlist";
    }

    saveWishlist(wishlistData);
    updateWishlistCount();
    refreshAllWishlistButtons();
}

/**
 * Removes a product from the wishlist
 * @param {string} variantId Variant ID to remove
 */
function removeFromWishlist(variantId) {
    let wishlistData = getWishlist();
    wishlistData = wishlistData.filter(item => item.epi !== variantId);
    saveWishlist(wishlistData);
    displayWishlist();
    updateWishlistCount();
}

/**
 * Displays the wishlist on the page
 */
function displayWishlist() {
    const wishlistData = getWishlist();
    const wishlistGrid = document.getElementById('wishlist-grid');
    const emptyWishlistBlock = document.querySelector('.emptyWishlist');

    if (!wishlistGrid || !emptyWishlistBlock) {
        console.error('Required element not found');
        return;
    }

    if (wishlistData.length === 0) {
        wishlistGrid.innerHTML = '';
        emptyWishlistBlock.style.display = 'flex';
        return;
    }

    emptyWishlistBlock.style.display = 'none';
    wishlistGrid.innerHTML = '';

    wishlistData.forEach(item => {
        if (!item.handle || !item.vo) {
            console.warn('Skipping item without handle or vo:', item);
            return;
        }

        const cleanHandle = item.handle.split('?')[0];
        const url = `/products/${cleanHandle}?variant=${item.epi}&view=wishlist-card`;

        fetch(url)
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.text();
            })
            .then(html => {
                const li = document.createElement('li');
                li.className = 'grid__item';

                const range = document.createRange();
                const nodes = range.createContextualFragment(html);
                li.appendChild(nodes);

                // Add remove button
                const removeButton = document.createElement('button');
                removeButton.className = 'remove-wishlist';
                removeButton.textContent = 'x';
                removeButton.addEventListener('click', () => {
                    const currentVariantId = li.querySelector('.product_item')?.dataset.currentVariantId || item.epi;
                    removeFromWishlist(currentVariantId);
                });

                li.appendChild(removeButton);
                wishlistGrid.appendChild(li);

                requestAnimationFrame(() => {
                    bindSizeButtons();
                });
            })
            .catch(error => {
                console.error(`Error loading product "${item.handle}" with variant "${item.vo}":`, error);
            });
    });
}

/**
 * Updates the wishlist button state on PDP
 * @param {HTMLElement} button Wishlist button element
 * @param {Array} wishlistData Wishlist data array
 * @param {string} variantId Variant ID to check
 */
function updateWishlistButton(button, wishlistData, variantId) {
    const wishlistText = button.querySelector('.wishlist_text');
    const isAlreadyInWishlist = wishlistData.some(item => item.epi === variantId);

    if (isAlreadyInWishlist) {
        button.classList.add('wishlist-added');
        if (wishlistText) {
            wishlistText.textContent = "Saved To Wishlist";
        }
    } else {
        button.classList.remove('wishlist-added');
        if (wishlistText) {
            wishlistText.textContent = "Save To Wishlist";
        }
    }
}

/**
 * Updates all wishlist buttons on the page
 */
function refreshAllWishlistButtons() {
    const wishlistData = getWishlist();

    const wishlistButtons = document.querySelectorAll('.wishlist_button');
    wishlistButtons.forEach(button => {
        const variantId = button.dataset.variantId;
        updateWishlistButton(button, wishlistData, variantId);
    });
}

/**
 * Optional: Updates Wishlist count badge (e.g. in header)
 */
function updateWishlistCount() {
    const count = getWishlist().length;
    const badge = document.querySelector('.wishlist-count-badge');
    if (badge) {
        badge.textContent = count > 0 ? count : '';
    }
}

/**
 * Generates a simple UUID
 */
function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0,
            v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

const wishlistObserver = new MutationObserver((mutationsList, observer) => {
    observer.disconnect();
    refreshAllWishlistButtons();
    setTimeout(() => {
        observer.observe(document.body, {childList: true, subtree: true});
    }, 200);
});

wishlistObserver.observe(document.body, {
    childList: true,
    subtree: true
});



function bindSizeButtons(container = document) {
    container.querySelectorAll('.button-popup-option').forEach(button => {
        if (!button.dataset.bound) {
            button.dataset.bound = 'true';
            console.log('[wishlist] bound size button', {
                variantId: button.dataset.variantId,
                label: button.dataset.variantLabel
            });

            button.addEventListener('click', function () {
                console.log('[wishlist] size button clicked', {
                    variantId: this.dataset.variantId,
                    label: this.dataset.variantLabel,
                    disabled: this.disabled,
                    hasDisabledClass: this.classList.contains('disabled')
                });
                if (this.disabled || this.classList.contains('disabled')) return;
                const variantId = this.dataset.variantId;
                const label = this.dataset.variantLabel;
                selectVariant(this, variantId, label);
            });
        }
    });
}

function selectVariant(button, variantId, variantLabel) {
    const modalDialog = button.closest('modal-dialog');
    const wrapper = button.closest('.product_variants_wrapper') || modalDialog?.openedBy?.closest('.product_variants_wrapper');
    console.log('[wishlist] selectVariant start', {
        variantId,
        variantLabel,
        foundModalDialog: !!modalDialog,
        foundWrapper: !!wrapper,
        openedBy: modalDialog?.openedBy || null
    });
    if (!wrapper) return;
    const productItem = wrapper.closest('.product_item');
    const previousVariantId = productItem?.dataset.currentVariantId;
    console.log('[wishlist] selectVariant context', {
        handle: productItem?.dataset.handle,
        previousVariantId,
        nextVariantId: variantId
    });

    // Update label
    const labelSpan = wrapper.querySelector('modal-opener span[data-selected-label]');
    if (labelSpan) labelSpan.textContent = variantLabel;
    console.log('[wishlist] updated selected label', { text: labelSpan?.textContent || null });

    // Update product-form hidden input
    const form = wrapper.querySelector('product-form');
    const input = form?.querySelector('input[name="id"]');
    if (input) input.value = variantId;
    console.log('[wishlist] updated hidden input', { value: input?.value || null });

    // Optional: keep button aria stable
    const submitButton = form?.querySelector('button[name="add"]');
    if (submitButton) {
        submitButton.dataset.variantId = variantId;
        submitButton.setAttribute('aria-label', `Add ${variantLabel} to cart`);
    }
    console.log('[wishlist] updated submit button', {
        foundSubmitButton: !!submitButton,
        submitVariantId: submitButton?.dataset.variantId || null
    });

    if (productItem) {
        const baseUrl = `/products/${productItem.dataset.handle}`;
        productItem.dataset.currentVariantId = variantId;
        productItem.dataset.url = `${baseUrl}?variant=${variantId}`;
    }
    console.log('[wishlist] updated product item dataset', {
        currentVariantId: productItem?.dataset.currentVariantId || null,
        url: productItem?.dataset.url || null
    });

    updateWishlistItemVariant(productItem, previousVariantId, variantId, variantLabel);

    closeWishlistModal(wrapper, modalDialog);

    wrapper.querySelectorAll('.button-popup-option').forEach((b) => b.classList.remove('is-selected'));
    button.classList.add('is-selected');
}

function closeWishlistModal(wrapper, modalDialogFromButton = null) {
    const modalDialog = modalDialogFromButton || wrapper.querySelector('modal-dialog');
    console.log('[wishlist] closeWishlistModal', {
        foundModalDialog: !!modalDialog,
        hasHideMethod: !!modalDialog && typeof modalDialog.hide === 'function',
        openAttrBefore: modalDialog?.hasAttribute('open') || false
    });
    if (modalDialog && typeof modalDialog.hide === 'function') {
        modalDialog.hide();
        console.log('[wishlist] modal hide() called', {
            openAttrAfter: modalDialog.hasAttribute('open')
        });
        return;
    }

    if (modalDialog) {
        modalDialog.removeAttribute('open');
    }
    document.body.classList.remove('overflow-hidden');
    console.log('[wishlist] modal fallback close complete', {
        openAttrAfter: modalDialog?.hasAttribute('open') || false,
        bodyOverflowHidden: document.body.classList.contains('overflow-hidden')
    });
}

function updateWishlistItemVariant(productItem, previousVariantId, nextVariantId, variantLabel) {
    if (!productItem || !nextVariantId) return;

    const handle = productItem.dataset.handle;
    const wishlistData = getWishlist();
    const existingIndex = wishlistData.findIndex(item =>
        item.handle === handle && item.epi === previousVariantId
    );

    if (existingIndex === -1) return;

    wishlistData[existingIndex].epi = nextVariantId;
    wishlistData[existingIndex].vi = variantLabel;
    wishlistData[existingIndex].uts = Date.now();
    wishlistData[existingIndex].pid = btoa(`${wishlistData[existingIndex].empi}-${nextVariantId}`);

    const duplicateIndexes = [];
    wishlistData.forEach((item, index) => {
        if (
            index !== existingIndex &&
            item.handle === handle &&
            item.epi === nextVariantId
        ) {
            duplicateIndexes.push(index);
        }
    });

    duplicateIndexes.reverse().forEach(index => wishlistData.splice(index, 1));
    saveWishlist(wishlistData);
    console.log('[wishlist] wishlist item updated', {
        handle,
        previousVariantId,
        nextVariantId,
        duplicateCountRemoved: duplicateIndexes.length
    });
}
